import * as constants from "../constants";
const LOG = false;

const handleResponse = async ({ response, onError }) => {
  LOG && console.log("response");
  LOG && console.log(response);
  if (response.redirected) {
    window.location.replace(`/?redirect=${window.location.pathname}`);
  } else if (response.status === 401) {
    window.location.replace(`/?redirect=${window.location.pathname}`);
  } else if (!response.body) {
    onError && onError(response.statusText);
    return { body: null, error: response.statusText };
  } else {
    try {
      const body = await response.json();
      LOG && console.log("body");
      LOG && console.log(body);
      if (body.error) {
        const error = constants[body.error] || constants.GENERIC_ERROR;
        return { body: null, error };
      } else {
        return { body, error: null };
      }
    } catch (err) {
      console.error("ERROR_PARSING_RESPONSE");
      console.error(err);
      return { body: null, error: constants.UNEXPECTED_ERROR };
    }
  }
};
export const fetchPost = async ({ data, url, onError }) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const { error, body } = await handleResponse({ response, onError });
    return { error, body };
  } catch (err) {
    console.error("ERROR: fetchPost");
    console.error("{ data, url, onError }");
    console.error({ data, url, onError });
    console.error(err);
    onError && onError(err);
    return { error: err, body: null };
  }
};

export const fetchGet = async ({ url, onError }) => {
  try {
    const response = await fetch(url, {
      method: "GET",
    });
    const { error, body } = await handleResponse({ response, onError });
    return { error, body };
  } catch (err) {
    console.error("ERROR: fetchGet");
    console.error("{ url, onError }");
    console.error({ url, onError });
    console.error(err);
    onError && onError(err);
    return { error: err, body: null };
  }
};
export const safeFetchGet = async ({ url, onError }) => {
  try {
    const response = await fetch(url, {
      method: "GET",
    });

    if (response.redirected || response.status === 401 || !response.body) {
      return false;
    }
    try {
      const body = await response.json();
      LOG && console.log("body");
      LOG && console.log(body);
      if (body.error) {
        return false;
      } else {
        return true;
      }
    } catch (err) {
      return false;
    }
    const { error, body } = await handleResponse({ response, onError });
    return { error, body };
  } catch (err) {
    console.error("ERROR: fetchGet");
    console.error("{ url, onError }");
    console.error({ url, onError });
    console.error(err);
    onError && onError(err);
    return { error: err, body: null };
  }
};

export const fetchDelete = async ({ data, onError, url }) => {
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const { error, body } = await handleResponse({ response, onError });
    return { error, body };
  } catch (err) {
    console.error("ERROR: fetchDelete");
    console.error("{ data, url, onError }");
    console.error({ data, url, onError });
    console.error(err);
    onError(err);
    return { body: null, error: err };
  }
};

export const fetchPut = async ({ data, onError, url }) => {
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const { error, body } = await handleResponse({ response, onError });
    return { error, body };
  } catch (err) {
    console.error("ERROR: fetchPut");
    console.error("{ data, url, onError }");
    console.error({ data, url, onError });
    console.error(err);
    onError(err);
    return { body: null, error: err };
  }
};
